import { APIClient, ApiQueryParams } from "@frontend/api-utils";
import { ColliExtended, ColliExtendedListResponse, ColliQueryParams } from "@frontend/colli/types";

export class ColliExtendedClient extends APIClient {
    public static readonly endpoint = '/colli-api/ext/v1';


    public static async fetchExtendedCollis(queryParams: ApiQueryParams<ColliQueryParams>): Promise<ColliExtendedListResponse> {
        return await this.apiPaginated<ColliExtendedListResponse, ColliQueryParams>(`${this.endpoint}/collis`, queryParams);
    }

    public static async fetchExtendedColli(accountId: string, transactionId: string, colliId: string): Promise<ColliExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}`);
        return await this.handleResponse<ColliExtended>(response);
    }
}